import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface LandingNavProps {
  mode?: 'marketing' | 'auth';
  onSignInClick?: () => void;
  onBack?: () => void;
}

export default function LandingNav({ mode = 'marketing', onSignInClick, onBack }: LandingNavProps) {
  return (
    <nav
      className="landing-nav fixed inset-x-0 top-0 z-[100] w-full border-b border-slate-200/70 bg-[var(--cream)] shadow-[0_1px_0_rgba(15,23,42,0.04)]"
      aria-label="Main"
    >
      <div className="landing-nav-inner flex min-h-[var(--landing-nav-height)] w-full items-center justify-between gap-4 py-3 pl-8 pr-8">
        <div className="flex min-w-0 flex-1 items-center">
          <Link to="/" className="landing-logo min-w-0 truncate">
            parachute<span className="iq">IQ</span>
          </Link>
        </div>
        <div className="flex shrink-0 items-center">
          {mode === 'marketing' && (
            <div className="landing-nav-right flex items-center gap-5 sm:gap-7">
              <a href="#pillars" className="landing-nav-link">
                Platform
              </a>
              <a href="#built" className="landing-nav-link">
                About
              </a>
              {onSignInClick && (
                <button type="button" onClick={onSignInClick} className="landing-nav-signin touch-manipulation">
                  Sign in
                </button>
              )}
            </div>
          )}
          {mode === 'auth' && onBack && (
            <button
              type="button"
              onClick={onBack}
              className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-[15px] font-medium text-[var(--ink-mid)] transition-colors hover:bg-slate-100/90 hover:text-[var(--ink)]"
            >
              <ArrowLeft size={18} strokeWidth={2} aria-hidden />
              <span>Back</span>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
